<div class="export-page" *ngIf="summary && !errorMessage">
	<div class="export-title" *ngIf="summary.title">
		<typography variant="h/1">{{ summary.title }}</typography>
	</div>

	<app-ai-summary-content
		*ngIf="summary.status === 'ready'"
		[content]="summary.content"
		[imageUrl]="summary.imageUrl"
		[entityType]="summary.entityType"
	></app-ai-summary-content>
</div>

<div class="export-error" *ngIf="errorMessage">
	{{ errorMessage }}
</div>
